import React from 'react';
import { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import { getListHistory } from "happ-redux/happ-actions/examenesMedicos/examenesMedicosActions";
import moment from "moment"

//happ-icons 
import { IconExamenes, IconHeart } from "happ-components/happ-icons/icons";
import './ResultadosMedicos.css';

import Result from 'happ-components/ResultadoMedico/Result';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Icon from "@material-ui/core/Icon";
import Card from "components/Card/Card.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import Favorite from "@material-ui/icons/Favorite";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import DateRange from "@material-ui/icons/DateRange";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import stylesDash from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";


const stylesPanel = {
    cardTitle,
    pageSubcategoriesTitle: {
      color: "#3C4858",
      textDecoration: "none",
      textAlign: "center",
    },
    cardCategory: {
      margin: "0",
      color: "#999999",
    },
  };

const ProfileStyle = makeStyles(styles);  
const useStyles = makeStyles(stylesPanel);
const dashStyles = makeStyles(stylesDash);
const ResultadosMedicos = () => {
const dispatch = useDispatch();

useEffect(() => {
    dispatch(getListHistory());
}, [])

const testList = useSelector(state => state.examenes.test_history);
const classes = useStyles();
const ProfileClass = ProfileStyle();
const DashClass = dashStyles();
    return ( 
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
            <Card>
                <CardHeader color="rose" icon>
                <CardIcon className={`${ProfileClass.iconBack} content-icons`}>
                    <IconExamenes />
                </CardIcon>
                <h4 className={ProfileClass.cardIconTitle}>
                    Mis Examenes
                </h4>
                </CardHeader>
                <CardBody>
                    <GridContainer >
                         {testList !== null ? (
                            Object.keys(testList).map(key => (
                                <GridItem xs={12} sm={6} md={6} lg={3} key={`${key}`} className="div_results">
                                     <Card className="">
                                        <CardHeader color="warning" stats icon>
                                            <CardIcon color="warning" className="icon-custom-test content-icons-grey">
                                                <IconHeart />
                                            </CardIcon>
                                            <p className={DashClass.cardCategory}>{key}</p>
                                            <h3 className={`${DashClass.cardTitle} icon-h3`}>
                                                {/* {list.last.value} <small>{list.last.unit}</small> */}
                                                <div className={DashClass.cardDivDate}>
                                                {/* <small className={DashClass.cardSmallDate}>{list.last.date}</small> */}
                                                </div>
                                            </h3>
                                        </CardHeader>
                                    <div className="card_results">
                                        {testList[key].map(obj => (
                                            <CardFooter stats key={obj.date}>
                                                <div className={`${DashClass.stats} icon-stats`}>
                                                    <DateRange />
                                                    {moment.utc(obj.date).format('YYYY-MM-DD')}
                                                </div>
                                                <div className={`${DashClass.stats} icon-stats`}>
                                                    <Favorite />
                                                    <Result 
                                                        obj={obj}
                                                        key={obj.date}
                                                    />
                                                </div>
                                            </CardFooter>
                                        ))}
                                    </div>
                                    </Card>
                                </GridItem>
                            ))
                        ) : null} 
                    </GridContainer>
                </CardBody>
            </Card>
            </GridItem>
        </GridContainer>
     );
}
 
export default ResultadosMedicos;